








































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import SendJobToWorkersRequest from '@/models/JobWorkers/SendJobToWorkersRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobWorkerSource from '@/models/JobWorkers/JobWorkerSource';

@Component({
    name: 'JobBrowseWorkersShortlist'
})
export default class extends GiganautVueDialog {
 
  sendWorkerEmail = true;
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.sendWorkerEmail = true;
    }
  }

  get loading() {
    return JobDetailsModule.loadingDialog;
  }

  get selectedWorkerIds() {
      return JobDetailsModule.browseWorkersVM.selectedWorkerIds;
  }

  async confirm() {  
    const request = new SendJobToWorkersRequest();
    request.workerIds = JobDetailsModule.browseWorkersVM.selectedWorkerIds;
    request.sendWorkerEmail = this.sendWorkerEmail;
    await JobDetailsModule.createJobWorkers(request);
    await JobDetailsModule.getJobWorkers();
    this.dialog = false;
  }
}
